import { createContext, useContext, useState, ReactNode } from "react";
import { DashBoardItem } from "../utilty";



// ✅ Context type
type DashboardContextType = {
    selectedItem: DashBoardItem | null;
    setSelectedItem: (item: DashBoardItem | null) => void;
    clearSelectedItem: () => void;
};

// ✅ Create context
const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

// ✅ Provider
export const DashboardProvider = ({ children }: { children: ReactNode }) => {
    const [selectedItem, setSelectedItem] = useState<DashBoardItem | null>(null);

    const clearSelectedItem = () => setSelectedItem(null);

    return (
        <DashboardContext.Provider
            value={{
                selectedItem,
                setSelectedItem,
                clearSelectedItem,
            }}
        >
            {children}
        </DashboardContext.Provider>
    );
};

// ✅ Custom hook (important)
export const useDashboard = () => {
    const context = useContext(DashboardContext);
    return context as DashboardContextType;
};